import React, { useState, useEffect } from 'react';
import CaseStudy from '../../../components/CaseStudy/CaseStudy';
import './CaseStudyWrapper.css';

// Wrapper component that provides CaseStudy with the right context
// and adds a completion button
const CaseStudyWrapper = ({ caseStudyId, caseStudy: initialCaseStudy, onComplete }) => {
  const [showCompletionButton, setShowCompletionButton] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const [error, setError] = useState(null);

  // Show completion button after user has scrolled/interacted
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setHasInteracted(true);
      }
    };

    const handleInteraction = () => {
      setHasInteracted(true);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('click', handleInteraction, { once: true });
    window.addEventListener('keydown', handleInteraction, { once: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('click', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
    };
  }, []);

  // Show completion button after some time or interaction
  useEffect(() => {
    if (hasInteracted) {
      const timer = setTimeout(() => {
        setShowCompletionButton(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [hasInteracted]);

  const handleComplete = () => {
    if (onComplete) {
      onComplete();
    }
  };

  // Use MemoryRouter to provide the case study ID as a route parameter
  // This allows CaseStudy component to use useParams() as it expects
  if (!caseStudyId) {
    return (
      <div className="case-study-wrapper" style={{ padding: '40px', textAlign: 'center' }}>
        <p>Case study ID is missing.</p>
        <button onClick={handleComplete} className="case-study-complete-btn" style={{ marginTop: '20px' }}>
          Continue to Next Step
        </button>
      </div>
    );
  }

  return (
    <div className="case-study-wrapper">
      <CaseStudy 
        embeddedId={caseStudyId}
        initialCaseStudy={initialCaseStudy}
        onComplete={handleComplete}
      />
      {showCompletionButton && (
        <div className="case-study-completion-overlay">
          <div className="case-study-completion-prompt">
            <h3>Ready to continue?</h3>
            <p>Once you've reviewed the case study, proceed to the next step.</p>
            <button 
              onClick={handleComplete}
              className="case-study-complete-btn"
            >
              Continue to Next Step
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CaseStudyWrapper;
